import { render, staticRenderFns } from "./ChecktestComplete.vue?vue&type=template&id=ab02045a&"
import script from "./ChecktestComplete.vue?vue&type=script&lang=ts&"
export * from "./ChecktestComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports